import { VERTICALS } from '@packages/types';
import { ALL_STEPS } from '../lib/steps';
const stringParam = 'string';
export const globalParams = {
    partner: stringParam,
    partnerId: stringParam,
    date: stringParam,
    time: stringParam,
    resourceId: stringParam,
    device: stringParam,
    deviceId: stringParam,
};
export const stepParams = {
    vertical: stringParam,
    speciality: stringParam,
    service: stringParam,
    city: stringParam,
    clinicId: stringParam,
};
export const allQueryParams = {
    ...globalParams,
    ...stepParams,
};
const getUrlParamsFromSteps = (steps) => steps.reduce((acc, { urlParams }) => {
    for (const [key, value] of urlParams) {
        acc[key] = value;
    }
    return acc;
}, {});
const getUrlParamsUpToStep = (allSteps, length) => {
    const stepsTilNow = allSteps.slice(0, length);
    return getUrlParamsFromSteps(stepsTilNow);
};
export const getAllParamsUpTo = (length) => getUrlParamsUpToStep(ALL_STEPS, length);
export const getAllParams = () => ({
    ...getUrlParamsFromSteps(ALL_STEPS),
    ...globalParams,
});
export function getStepFilledToNow(steps, query) {
    if (!Array.isArray(steps) ||
        typeof query !== 'object' ||
        Array.isArray(query)) {
        return 0;
    }
    let stepsFilledTillNow = 0;
    for (const { urlParams } of steps) {
        if (urlParams.length === 0 ||
            !urlParams.every(([param]) => Boolean(query[param]))) {
            break;
        }
        stepsFilledTillNow += 1;
    }
    return stepsFilledTillNow;
}
const urlParameterKeys = new Set(Object.keys(getAllParams()));
const isUrlParameterKey = (key) => urlParameterKeys.has(key);
const isVertical = (value) => VERTICALS.some((vertical) => vertical === value);
export const normalizeQuery = (query) => Object.entries(query).reduce((normalizedQuery, [key, value]) => {
    if (!isUrlParameterKey(key) || typeof value !== 'string') {
        return normalizedQuery;
    }
    if (key === 'vertical') {
        if (isVertical(value)) {
            normalizedQuery.vertical = value;
        }
    }
    else {
        normalizedQuery[key] = value;
    }
    return normalizedQuery;
}, {});
